// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://dataservice.iifl.in/ClipCoreAPI/uat/',
  brokingUat: 'https://broking-uat-westindia-apigateway.azure-api.net/refernearn/',
  gaKey: 'G-0SE9B30YMJ',
  OcmKey: {
    'Ocp-Apim-Subscription-Key': '7ae0a07b98074dfd8f040798f93b91fe',
  },
  logoutUrl: "http://iiflaaadev.brainvire.net/",
  curtlyOcmKey: {
    'Ocp-Apim-Subscription-Key': 'ec6d5883c59c46768b6a1431913ab654'
  },
  influencerUrl:{
	  'authkey': "IndiaInfoline_CliPlGtW3YlDElmt7Ed9kYXEJAHsvzMWA4L0V"
	}

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
